import { render } from "./PsButton.vue?vue&type=template&id=1b5eca48&ts=true"
import script from "./PsButton.vue?vue&type=script&lang=ts"
export * from "./PsButton.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__